<template>
  <div class="park-info-header">
    <div class="common-card-panel park-info show-radius show-shadow">
      <div class="info-head">
        <div class="park-name">
          <span class="name">{{$route.query && $route.query.parkName || '--'}}</span>
          <!-- <el-tag effect="dark" color="#5793fc" size="small">国家级</el-tag>
          <el-tag effect="dark" color="#f76c6c" size="small">高新技术产业开发区</el-tag>
          <el-tag effect="dark" color="#f09557" size="small">先进制造业百强园区</el-tag> -->
          <el-tag color="#186bfc" size="small" class="area-tag">{{$route.query && $route.query.province || '--'}}</el-tag>
          <el-tag color="#186bfc" size="small" class="area-tag">{{$route.query && $route.query.city || '--'}}</el-tag>
        </div>
        <div class="park-switch-type">
          <span v-for="(item,index) in switchTypeOption" :key="index" :class="item.value == switch_type ? 'is-active' : ''" @click="switchTypeChange(item.value)">{{item.name}}</span>
        </div>
      </div>
      <div class="park-industry">
        <span class="item-name">详细地址：{{addressName}}</span>
        <!-- <el-tag effect="dark" size="small" plain>{{$route.query && $route.query.province || '--'}}</el-tag>
        <el-tag effect="dark" size="small" plain>{{$route.query && $route.query.city || '--'}}</el-tag> -->
      </div>
    </div>
    <div class="statistical-panel fx-s-center">
      <div class="common-card-panel show-shadow show-radius" v-for="(item,index) in statisticalOption" :key="index">
        <div>
          <span class="panel-icon"></span>
          <span class="fx-c">
            <span class="type">{{item.name}}</span>
            <span class="total">{{item[`${switch_type}Number`] > 0 ? Global.formatThousandSeparator(item[`${switch_type}Number`]) : 0}}</span>
          </span>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'parkInfoHeader',
  props: {
    switchType: {
      default: () => 'reg'
    },
    switchTypeOption: {
      type: Array,
      default: () => []
    },
    statisticalOption: {
      type: Array,
      default: () => []
    }
  },
  components: {},
  data() {
    return {
      switch_type: this.switchType,
    }
  },
  computed: {
    addressName() {
      const route = this.$route
      let address = route.query && route.query.province
      let city = route.query && route.query.city
      return (address || city) ? address + city : '--'
    }

  },
  watch: {
    switchType(val) {
      this.switch_type = val
    },
    switch_type(val) {
      this.$emit('update:switchType',val)
    }
  },
  mounted() {
  },
  created: function () {
  },
  methods: {
    switchTypeChange(val) {
      if (val !== this.switch_type) {
        this.switch_type = val
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.park-info-header {
  .park-info {
    padding: 16px !important;
    .info-head {
      display: flex;
      justify-content: space-between;
    }
    .park-name {
      display: flex;
      align-items: center;
      padding: 0 0 16px;
      .name {
        font-size: 1.4285714286rem;
        font-weight: 600;
        color: #333;
        margin-right: 16px;
      }
      ::v-deep .el-tag {
        color: #fff;
        margin-right: 8px;
      }
      .area-tag {
        border-radius: 10px;
      }
    }
    .park-switch-type {
      display: inline-block;
      height: 24px;
      span {
        display: inline-block;
        width: 70px;
        height: 100%;
        line-height: 23px;
        text-align: center;
        font-size: 1rem;
        font-weight: 400;
        color: #86909c;
        cursor: pointer;
        border: 1px solid #d7dae2;
      }
      .is-active {
        color: #186bfc;
        border-color: #186bfc;
      }
    }
  }
  .park-industry {
    padding-bottom: 16px;
    .item-name {
      font-size: 0.8571428571rem;
      font-weight: 500;
      color: #333;
    }
    ::v-deep .el-tag {
      background-color: #fff;
      border-color: #a3c4fe;
      color: #186bfc;
      margin-right: 8px;
    }
  }
  .statistical-panel {
    justify-content: flex-start;
    flex-wrap: nowrap;
    margin-top: 16px;
    .common-card-panel{
      width: calc(25% - 12px);
      margin-left: 16px;
      padding: 24px 0;
      &:first-child {
          margin-left: 0;
      }
      div {
        display: flex;
        align-items: center;
      }
    }
    .panel-icon {
      width: 60px;
      height: 60px;
      border-radius: 8px;
      margin-left: 30px;
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAAXNSR0IArs4c6QAAAm1QTFRFAAAA////////29v/0ej/3e7/1uD/1uv/1ub/1+f/1+v/2OX/2ef/1eP/1+P/1+f/0+P/1eb/1eP/1eT/1+b/1eT91eT/1OT91ub/1eT/1uT91uT/1ub/1eb/1eT+1eT/1uT/1uT/1uX/1eT+1eT/1eX/1uT+1eX/1OT+1eX+1uX/1uT+1uT/1eT/1eT+1uX/1uX/Lnf3Lnj3Lnj4Lnj5Lnj6Lnj7Lnn7Lnn8L3byL3j3L3j4MHbxMXbuMXv8MnTmMnToM3LiM3PiM3PjM3z7M3z8NHHaNHv3OG3JOWvDOmvCO4L8PIL8P4T8TY38V5H4WJD0Xpj8ZZv6ZZz8b6D4cqP3eKj8far4fqbtfqn2fqz8fqz9f6fuf639ja3nja7nkbn9krn9mb39m734q8n9u9P9v9X9wNb9wNb+xdj7yNXsyNXtyNn3yNn4ydbsytz7yt3+y9fuzNnwzdnuzdrwzd/+ztvxz9vy0N3z0N300t700t/1093w097x0+D30+P+1OP+1eT+1uT71uT81+T61+T82OT42OT62OX72eLy2eT42eX32eX52eb82uP02uT22uT32uX52uX62uf92+f92+f+2+j93Of43eb23eb33en93en+3uf43un93+j43+r93+r+4ef14ej34ev+4un24ur34ur44uz+4+3+5O3+5O7+5ev55e7+5uz45u355/D+6PD+6e/56vD66vH+6/L+7PP+7fL67fP97fP+7vL77vT+7/P77/T/8PX+8Pb+8fb+8vb+8vf+8/f+9Pb79fj+9fn+9vn/+Pr++Pv++fv/+vz/+/z++/z//P3//f7/18440wAAADF0Uk5TAAECBwsPGRkfICYnNTY/P1JbXGZmeXmDg42OoKCqq7W1xsbPz+Pk6ery8vb2+f39/gaAxlEAAAJMSURBVDjLY2DAAFzy8lwMhAGrpG5jo64kKwFlTMLqjWCgLsyETx2fciMcKPPhVMYha9CIBAxkObAqYxHXbkQD2uIsGMoYBVVh0qmBgakwtqogI6o6HkWYVEGYnYWFXVgBjK/Ig6SMTVoPKlyf6GMBBj6J9VAhPWk2qDJmUU2Y9hQ/CzjwS4GJaooygxUKwATSgy1QQHA6TEYAWWFprKsFGnCNLcVQ2JDki1BgbmpsZGRtamZh4ZvUgKYwA8kgc+PQA+fOnUi2Aqq0yMCp0NzM1Cb3zJlTp47YmuJRaG7iHx4Z0X0cBOyt8Sg0CTh99vDC3UdAwNEIh0KgpcaWMSdO7OzcdAgIDjoZYldobhKSmZ9Tdezoxpp1e0EAl0JTm+0nT25bcuDA6uJlO0AAl0JjB6C71vbt2bU0b85mEMCl0Mh53/79i2q3bJmX1b9+/YYNG3ApNHTaunXrjJING2ZmT1gDBKtwKwSa0l+2atX0wq7lIIBb4YqVKydULF48sahnwYL58+fjdKPjtAUL2qrnzp1U3j579qxZvbgC3No+vnVKS93UyR2VTZMnT26OwxqFwGRmauvm4ekFA54ebsBEgZnMgAk3yt3W3tEJBhztba1cokuxpPDGxrQga0MEsDZFzwrMYlr4M5eWGDM0H7LL6MOya4I3RJl3Aiy76suwI+VsXiVcBYASL1qRIqSGrUhRE2LELKQkdNALKR0JFqzlGaccarEnx4mzhORXQahT4cdbNItoQJRpiDARKuylQIW9FCsR9QK3ggI3pigAAQCuUdkFpO8AAAAASUVORK5CYII=) 50% no-repeat, #eaf1fe;
    }
    .common-card-panel:nth-child(2) .panel-icon{
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAAXNSR0IArs4c6QAAAkZQTFRFAAAA/////////9vb/9HR/93d/9bW/+Dg/97e/9fX/93d/9jY/93d/9nZ+9vb/9vb/Nra/93d/Nvb/dra/9zc/dnZ/dvb/dra/9zc/dvb/dnZ/dra/tvb/tra/tra/tra/tvb/tra/tvb/dra/tvb/dra/dra/tra/dra/tvb/tra/dra/tvb/tvb6ktL6kxL60tL7ExL7UpK7UtK7UxM7U9O7U9P7VNS7kpK7lBP7l1c70lJ8EpJ8GRk8YOC8YSD8khI8nNy8oiH8o2M80hI80lI81pZ84iI85KS9EhI9IqK9IuJ9I+O9I+P9UhI9UpK9Wdn9W1t9ZCP9ZiX9Z2c9Z+e9khI9kpK9ktL9kxM9k1N9k5O9lNT9lRU9ldX9lhY9l1d9pyc91pa915e92Nj92Zl92dn94eH95mZ95+e96in96qq962s+HJy+Hh4+H5++I2N+JGR+J2d+LKx+LW0+L29+YiI+YmJ+Y6O+b29+b69+b+++cDA+p+f+qWl+qem+ra2+rq5+r69+srK+6qp+66u+7W1+8jI/MPD/MbG/MfH/MjI/MrK/MvK/M7O/NHR/NLS/NPS/NPT/NXV/Nva/ODg/dLR/dTT/dXU/dXV/djY/dnZ/dra/dvb/dzb/d3c/d7d/d/f/ePj/eTk/tnZ/tva/t3d/t7d/t7e/t/e/t/f/uDf/uDg/uHg/uHh/uLh/uPi/uTj/uTk/uXk/uXl/ubl/ubm/ufn/ujn/ujo/urq/uvq/uvr/uzr/uzs/u3t/u7u/vDwAZb36wAAAC50Uk5TAAECBwsPGRkfICYnNTY/P1JbXGZmeXmDg42OoKqrtcbGz+Pk6ery8vb2+f39/lTGOlsAAAIISURBVDjLY2DAAFxyclwMhAGrpNacOVqSrASUMQmrzAEDFWEmfOr4FOfAgSIfTmUcMrpzkICuDAdWZSziGnPQgIY4C4YyRkElmHRHbm4HjK0kyIiqjkceJtVfHhEWFlHeD+PL8yApY5PWhgrPqo0NA4PY2llQIW1pNqgyZlE1mPa2lDA4SGmDiaqJMoMVCsAEuvLCUEBeF0xGAFnhpIooJEXR+UAiqmIShsLZdXEophU0+IGouLrZaAq7UW2NX9zkB2F141UY03cww5MIhakzD0y1rSeoMLll1/5FdpPne+JVGJ7Wum/vnmb7Kbu2uOJTmNBTtGnXQmePDTu3z3XBozBpzu7g0gU5Ndu2bt1cgsdEv7YdoWZWG32XbdywYb0jHjd6Lqg2di3c4L5u7ZrVWTZ+uBW6TJgY4N+5ymvlivmVlvjC0dNn9cr05e2Z85YWm7vgixk/C6eqxLnZjbNDDB2g6nD42sXapHdJ0LSZpjDzcCn08wucMcN7+nQ3uDoMhbBk5qCnb6RvALcYM5mBEm4kyD8uLi4OMIsjsSRcYrICs5g6/sylLsYMzYfs0jq4s6uONDtSzuZVgBcAZaACoAxeACjwohUpQsrYihRlIUbMQkpCE72Q0pRgwVqeccqiFnuynDhLSH7kgpQfb9EsogpRpirCRKiwlwIV9lKsRNQL3HJy3JiiAAsN46iatsG2AAAAAElFTkSuQmCC) 50% no-repeat, #feeded;
    }
    .common-card-panel:nth-child(3) .panel-icon{
      background: url(data:image/png;base64,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) 50% no-repeat, #eaf7ec;
    }
    .common-card-panel:nth-child(4) .panel-icon{
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAAXNSR0IArs4c6QAAAohQTFRFAAAA/////////9vb/+jR/+7d/+DW/+vW/+bW/+fX/+vX+OXY/+fZ+uPV++PX++fX/OPT/ObV/OPV+uTV/ebX++TV/eTV++TU/ebW++TV++TW/OTW/ObW/ObV++TV/OTV/OTW++TW++XW++TV/OXV/OTW/OXV++TU++XV/OXW++TW/OTW/OTV++TV/OXW/OXW1nYr13Yr2HYr2Hcr2XYr23cr4Hgs4Xks43gs43ks43kt5Hgt5Hks5Hkt5Xks5Xkt5nkt6Hkt6Hot6Xkt6not6otJ63ot63ou63st63su66t57Hot7Hou7Hst7Hsu7Xsu7X0x7X4z7YpG7Zld7aNv7oM77oM87oU/7oY/7pRW7pVX7raK745N8Zle8Z1l8ad08cKf8rKG86l4861+865/9bmR9bqS9cKe9r6Z9syp9s2w9s+t98qr99C099K299S0+JVD+JVE+NSz+NS7+aNb+aNd+dS7+dbA+dfA+dq/+dzB+d/I+qxr+q1t+tm6+t3K+t/N+uDJ+uLL+uLM+9/E+9/F++DI++HI++HJ++PN++PT++PU++TV/M6o/NCs/OLK/OnX/O7j/O/k/da2/di6/d/G/eLL/ebR/ezc/e/h/uvY/uvZ/uva/uzb/u3c/u3e/u7f/u/g/vDg/vDi/vLn/vTp/vXs/vbt/vbv/vfw/vjx/vjy/vr2/+3c/+3d/+7e/+/f/+/g/+/h//Dh//Di//Dj//Hj//Hk//Ll//Lm//Ln//Pm//Pn//Po//Pp//Tp//Tq//Tr//Xq//Xr//Xs//Xt//bt//bu//bv//fv//fw//jw//jx//jy//jz//nz//n0//r1//r2//v2//v3//v4//v5//z5JgoLWQAAADB0Uk5TAAECBwsPGRkfICYnNTY/P1JbXGZmeXmDg42OoKCqq7W1xsbP4+Tp6vLy9vb5/f3+M8aLqgAAAnFJREFUOMtjYMAAXPLyXAyEAaukTk+PjiQrAWVMwmo9YKAmzIRPHZ9yDxwo8+FUxiGr34ME9GU5sCpjEdfqQQNa4iwYyhgFVWDSZbGxZTC2iiAjqjoeRZhUfVKAv39AUj2Mr8iDpIxNWhcq3JUW5g8GYWldUCFdaTaoMmZRDZj2nBh/OIjJgYlqiDKDFQrABMrj/FFAXDlMRgBZYUNKIFSBr68vhBGY0oChsDsjAqLIxy0oPj3ZA6o0IqMbTWEFSNjPMzIxd+K1q1cuB7vD7K/AotDXJe/61atXLl26uCrEBZ9CH4c156YtuHhh9bIVCa5ufr44FbrZXuorKD27cubqK1euT8yK8sap0OrClMLaM0s6z124eOnK1UnOfjgVnjk6dc7yCVWnzpw9D1Rr74tT4cnegpKlnfnHTpw8DVRr5YZT4bHJhTWLO7IPHT5y/PjJU3gUHj6wf+/Ctsy9+w4cPHL0GB6F+/fu2r2oNXvHzl0gtXgU7ty5Y/um/qKt27fv2LlnLx6F27dt27J5et3GjZu3bNu+A7dCixmbN27YMKtl3vr1QLXzLXEqtPOqbm5qaqxsn7123fq50bbYFHZnhPv7OpmbGhkbGxsZGhoYGJqYOfn4h2MkM2DCTQ50c7S3sbW1tba0sLKysnVyCUxuwJLCQVnBz9vHw8PNDYiAwAc9KzCLaeLPXJpizNB8yC6jB8uuqaEQZaGpsOyqJ8OOlLN5lXAVAEq8aEWKkCpMqjg2thjGVhVixCykJLTRCyltCRas5RmnHGqxJ8eJs4TkRy5I+fEWzSLqEGXqIkyECnspUGEvxUpEvcCtoMCNKQoAvqbfLIMBOg0AAAAASUVORK5CYII=) 50% no-repeat, #fdf2ea;
    }
    .fx-c {
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      margin-left: 16px;
      .type {
        font-size: 1rem;
        font-weight: 400;
        color: #333;
      }
      .total {
        font-size: 1.7142857143rem;
        font-weight: 500;
        color: #333;
      }
    }
  }
}
</style>